export class ContributoUnificato {
    id?: string;
    tipoContributo: string;
    valoreImportoFisso: string | number;
    valoreScaglione: string;
    contributoCalcolato: string | number;
}